export default __webpack_public_path__ + "58db52102d3071c36d5af8aa4c9ede35.png";